import React from "react"
//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import InvoicesTable from "./InvoicesTable"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

export default function InvoicesList() {

  const { t } = useTranslation()

  const {state} = useLocation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={(state?.companyName ? state.companyName + ", " + state.contractName : "") + " Invoices"} />
        <InvoicesTable />
      </div>
    </div>
  )
}
